<template>
    <div class="step-5">
        <div class="row">
            <div class="col-md-10 offset-md-1">
                <div class="row">
                    <div class="payment-card-wrap col-md-6" v-for="(item, i) in paymentOptions" :key="i">
                        <div class="payment-card">
                            <img v-if="item.payment_option" :src="item.payment_option.logo_asset" alt="">
                            <button class="btn btn-primary btn-shadow text-uppercase" @click.prevent="selectPaymentOption(i)">
                                {{ $t('choose_val', {value: item.payment_option.name}) }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .payment-card {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        margin-bottom: 30px;
        padding: 40px 60px;
        background-color: var(--bg-color);

        &:hover {
            box-shadow: 0 5px 15px rgba(#000, .15);
        }

        > img {
            max-width: 100%;
            height: auto;
            margin: 20px 0 40px;
        }
    }

    body.-is-mobile {

        .payment-card {
            padding-left: 20px;
            padding-right: 20px;
            margin-bottom: 1rem;

            &-wrap:last-child {

                .payment-card {
                    margin-bottom: 0;
                }
            }
        }
    }
</style>

<script>
  import checkoutStep5 from 'src/mixins/checkoutStep5Component';

  export default {
    mixins: [checkoutStep5],
  };
</script>
